"use strict";

module.exports = ["#eee", "#d6e685", "#8cc665", "#44a340", "#1e6823"];